<template>
    <div class="float-left" >
        <i
            class="fa fa-search-plus fa-lg icon-button"
            title="Visualizar"
            @click.stop="abrirModal()"
        ></i>
        <b-modal
            id="modalDoc"
            size="xl"
            v-model="mostrarModal"
            no-close-on-backdrop
            style="height:50%; margin: 0;"
        >
            <div slot="modal-title">
                Visualizar Documentos - {{nomeDoc}}
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
                <iframe
                    v-if="arquivo"
                    v-bind:src="arquivo"
                    style="width:100%; height:600px;"
                >
                </iframe>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        parentData: [],

        servicos: {
            type: Object,
            default: () => ({})
        },
    },

    data(){
        return {
            mostrarModal: false,
            erros: [],
            arquivo: [],
            nomeDoc: "",
            doctypes: {
                "JPG": "image/jpg",
                "PNG": "application/png",
                "BMP": "application/bmp",
                "PDF": "application/pdf",
                "TML": "text/html",
                "TXT": "text/plain",
                "XML": "text/xml",
                "DOC": "application/msword",
                "OCX": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "XLS": "application/excel",
                "LSX": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "RTX": "text/richtext"

            }
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true;
            this.visualizar(this.parentData);
            this.nomeDoc = this.parentData.nomeArquivoOriginal;
        },

        fecharModal() {
            this.mostrarModal = false;
            this.arquivo = null;
        },

        visualizar(doc) {
            this.servicos.baixarAnexo(doc).then(response => {
                if (response) {
                    if (response) {

                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao realizar download do anexo!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            let tamanho = doc.nomeArquivoOriginal.length
                            let tipo = doc.nomeArquivoOriginal.substring(tamanho-3, tamanho).toUpperCase()
                          
                            if ( !(tipo in this.doctypes) ) {
                                this.$toast.error(
                                    'Erro ao abrir arquivo devido a formatação',
                                    'ERROR',
                                    this.$toastConfig.error
                                )
                                return
                            }

                            let typeArq = this.doctypes[tipo];
                            const blob = new Blob([response], {type: typeArq});
                            this.arquivo = window.URL.createObjectURL(blob);
                        }
                    }
                }
            })
        },
    },
}

</script>
